// extracted by mini-css-extract-plugin
export default {"wrapper":"hijEf","input":"syQlg","text-area":"pCuQ0","input-form":"s5eIs","text-wrapper":"ZAPZd","specialization-input":"wqvsA"};